import { Lock, TriangleAlert } from "lucide-react";

import { cn } from "../../lib/utils";

interface BudgetInputCapProps {
  className?: string;
}

export const BudgetInputCap = ({ className }: BudgetInputCapProps) => (
  <div
    className={cn(
      "flex items-center gap-2 border-b border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-100 px-3.5 py-2 dark:border-amber-700 dark:from-amber-950/40 dark:to-amber-900/30",
      className,
    )}
  >
    <Lock className="h-3 w-3 shrink-0 text-amber-700 dark:text-amber-400" />
    <span className="text-xs font-medium text-amber-800 dark:text-amber-200">
      Budget limit reached — contact your admin to continue
    </span>
  </div>
);

interface BudgetStandaloneCardProps {
  message?: string;
  className?: string;
}

export const BudgetStandaloneCard = ({
  message = "Budget limit reached — contact your admin to continue.",
  className,
}: BudgetStandaloneCardProps) => (
  <div
    className={cn(
      "flex items-center gap-2.5 rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 px-3.5 py-2.5 dark:border-amber-700 dark:from-amber-950/30 dark:to-amber-900/20",
      className,
    )}
  >
    <TriangleAlert className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
    <p className="text-sm font-medium text-amber-900 dark:text-amber-200">
      {message}
    </p>
  </div>
);
